/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateAllowRegistrationDomainDataParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('allow')],
    ['domain', codecString],
    ['tenantRoleId', codecNumber, 'tenant_role_id'],
    [
        'matchSubdomains',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'match_subdomains',
    ],
]);
export class CreateAllowRegistrationDomainData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateAllowRegistrationDomainDataParser.decode(input).map(res => new CreateAllowRegistrationDomainData(res));
    }
    static unsafeDecode(input) {
        return CreateAllowRegistrationDomainData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateAllowRegistrationDomainDataParser.encode(data);
    }
    static schema() {
        return CreateAllowRegistrationDomainDataParser.schema();
    }
}
